import { Component, OnInit, Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';

@Component({
  selector: 'body-comments-form',
  templateUrl: './body-comments-form.component.html',
  styleUrls: ['../../../work-orders.component.scss',
    '../../../../ve.component.scss'
  ]
})
export class BodyCommentsFormComponent implements OnInit {
  workOrdersService: WorkOrdersService;

  constructor(injector: Injector) {
    this.workOrdersService = injector.get(WorkOrdersService);
  }

  ngOnInit() {
    //this is kept empty on purpose
  }
}
